import React from 'react';

/**
 * Horizontal strip of pinned contract cards between scatter plot and heatmap.
 */
function ExplorerPinnedStrip({ contracts, currentScenario, onUnpin }) {
  const getScenarioReturn = (contract) => {
    const key = String(currentScenario);
    return contract.scenarios?.[key]?.pct_return ?? null;
  };

  return (
    <div className="bg-gray-800/50 rounded-lg p-3">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-xs font-semibold text-gray-300">
          Pinned Contracts ({contracts.length}/8)
        </h4>
        <span className="text-xs text-gray-500">Scroll right for more →</span>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {contracts.map((c) => {
          const ret = getScenarioReturn(c);
          return (
            <div
              key={`${c.ticker}_${c.strike}_${c.expiration}`}
              className="flex-shrink-0 bg-gray-700 rounded-lg p-3 min-w-[180px] relative"
            >
              {/* Unpin button */}
              <button
                onClick={() => onUnpin(c)}
                className="absolute top-1 right-1 text-gray-500 hover:text-red-400 text-sm w-5 h-5 flex items-center justify-center"
              >
                ×
              </button>

              <div className="text-sm font-bold text-white">
                {c.ticker} ${c.strike}
              </div>
              <div className="text-xs text-gray-400">
                {c.expiration} · {c.dte}d · {c.moneyness_label}
              </div>
              <div className="text-xs text-gray-400 mt-1">
                IV: {(c.iv * 100).toFixed(1)}% · Prem: ${c.premium?.toFixed(2)}
              </div>
              {ret !== null && (
                <div className={`text-sm font-bold mt-1 ${ret >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                  {ret >= 0 ? '+' : ''}{ret.toFixed(1)}%
                  <span className="text-xs text-gray-500 font-normal ml-1">
                    at {currentScenario > 0 ? '+' : ''}{currentScenario}%
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ExplorerPinnedStrip;
